import Helmet from 'react-helmet';

/*
  window title format: {detail} {pageTitle} {env}, where
  detail of the page e.g. name of project, name of group, name of user
  page is the location e.g. Team Members, User Access, User Details
  env is provided by helmet default config. See app.tsx
*/
export interface WindowTitleProps {
  detail?: string;
  pageTitle: string;
}

export const WindowTitle = ({ detail, pageTitle }: WindowTitleProps) => (
  <Helmet>
    <title>{formatWindowTitle(detail, pageTitle)}</title>
  </Helmet>
);

const formatWindowTitle = (detail?: string, page?: string) => {
  return [detail, page].filter(Boolean).join(' - ');
};
